export const CURRENCY_SYMBOLS = {
  EUR: "€",
  USD: "$",
  GBP: "£",
  AUD: "A$",
  NZD: "N$",
  CAD: "CAD$",
  JPY: "¥",
  NONE: "",
};
